import React from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { Shield, Sparkles } from "lucide-react";
import { Link } from "react-router-dom";

// Purple-first badge (was green — user redirect Feb 18 2026).
const style = (variant = "purple") => ({
  purple: {
    border: "1px solid rgba(168,85,247,0.35)",
    background: "var(--accent-soft)",
    color: "var(--accent)",
  },
  sky: {
    border: "1px solid rgba(56,189,248,0.35)",
    background: "rgba(56,189,248,0.10)",
    color: "#7DD3FC",
  },
}[variant]);

export default function TrialBadge() {
  const { data } = useQuery({
    queryKey: ["billing-status"],
    queryFn: async () => (await api.get("/billing/status")).data,
  });

  if (!data) return null;

  if (data.status === "active") {
    return (
      <Link to="/pricing" data-testid="trial-badge"
        className="inline-flex items-center gap-2 px-2.5 py-1 text-[10px] font-medium tracking-wider transition-colors"
        style={{ ...style("purple"), borderRadius: "8px" }}>
        <Shield className="h-3 w-3" strokeWidth={1.5} /> PRO · {data.days_left_sub}D
      </Link>
    );
  }
  if (data.status === "trialing") {
    return (
      <Link to="/pricing" data-testid="trial-badge"
        className="inline-flex items-center gap-2 px-2.5 py-1 text-[10px] font-medium tracking-wider transition-colors animate-pulse"
        style={{ ...style("purple"), borderRadius: "8px" }}>
        <Sparkles className="h-3 w-3" strokeWidth={1.5} /> TRIAL · {data.days_left_trial}D LEFT
      </Link>
    );
  }
  return (
    <Link to="/pricing" data-testid="trial-badge"
      className="inline-flex items-center gap-2 px-2.5 py-1 text-[10px] font-medium tracking-wider transition-colors"
      style={{ ...style("sky"), borderRadius: "8px" }}>
      <Sparkles className="h-3 w-3" strokeWidth={1.5} /> FREE TRIAL
    </Link>
  );
}
